
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('generic/preload_file',["require", "exports", '../core/file', '../core/buffer', '../core/api_error', '../core/node_fs'], function(require, exports, file, buffer, api_error, node_fs) {
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;
    var fs = node_fs.fs;
    var Buffer = buffer.Buffer;

    var PreloadFile = (function (_super) {
        __extends(PreloadFile, _super);
        function PreloadFile(_fs, _path, _flag, _stat, contents) {
            _super.call(this);
            this._pos = 0;
            this._fs = _fs;
            this._path = _path;
            this._flag = _flag;
            this._stat = _stat;
            if (contents != null) {
                this._buffer = contents;
            } else {
                this._buffer = new Buffer(0);
            }

            if (this._stat.size !== this._buffer.length) {
                throw new Error("Invalid buffer: Buffer is " + this._buffer.length + " long, yet Stats object specifies that file is " + this._stat.size + " long.");
            }
        }
        PreloadFile.prototype.getPath = function () {
            return this._path;
        };

        PreloadFile.prototype.getPos = function () {
            if (this._flag.isAppendable()) {
                return this._stat.size;
            }
            return this._pos;
        };

        PreloadFile.prototype.advancePos = function (delta) {
            return this._pos += delta;
        };

        PreloadFile.prototype.setPos = function (newPos) {
            return this._pos = newPos;
        };

        PreloadFile.prototype.sync = function (cb) {
            try  {
                this.syncSync();
                cb();
            } catch (e) {
                cb(e);
            }
        };

        PreloadFile.prototype.syncSync = function () {
            throw new ApiError(14 /* ENOTSUP */);
        };

        PreloadFile.prototype.close = function (cb) {
            try  {
                this.closeSync();
                cb();
            } catch (e) {
                cb(e);
            }
        };

        PreloadFile.prototype.closeSync = function () {
            throw new ApiError(14 /* ENOTSUP */);
        };

        PreloadFile.prototype.stat = function (cb) {
            try  {
                cb(null, this._stat.clone());
            } catch (e) {
                cb(e);
            }
        };

        PreloadFile.prototype.statSync = function () {
            return this._stat.clone();
        };

        PreloadFile.prototype.truncate = function (len, cb) {
            try  {
                this.truncateSync(len);
                if (this._flag.isSynchronous() && !fs.getRootFS().supportsSynch()) {
                    this.sync(cb);
                }
                cb();
            } catch (e) {
                return cb(e);
            }
        };

        PreloadFile.prototype.truncateSync = function (len) {
            if (!this._flag.isWriteable()) {
                throw new ApiError(0 /* EPERM */, 'File not opened with a writeable mode.');
            }
            this._stat.mtime = new Date();
            if (len > this._buffer.length) {
                var buf = new Buffer(len - this._buffer.length);
                buf.fill(0);

                this.writeSync(buf, 0, buf.length, this._buffer.length);
                if (this._flag.isSynchronous() && fs.getRootFS().supportsSynch()) {
                    this.syncSync();
                }
                return;
            }
            this._stat.size = len;

            var newBuff = new Buffer(len);
            this._buffer.copy(newBuff, 0, 0, len);
            this._buffer = newBuff;
            if (this._flag.isSynchronous() && fs.getRootFS().supportsSynch()) {
                this.syncSync();
            }
        };

        PreloadFile.prototype.write = function (buffer, offset, length, position, cb) {
            try  {
                cb(null, this.writeSync(buffer, offset, length, position), buffer);
            } catch (e) {
                cb(e);
            }
        };

        PreloadFile.prototype.writeSync = function (buffer, offset, length, position) {
            if (position == null) {
                position = this.getPos();
            }
            if (!this._flag.isWriteable()) {
                throw new ApiError(0 /* EPERM */, 'File not opened with a writeable mode.');
            }
            var endFp = position + length;
            if (endFp > this._stat.size) {
                this._stat.size = endFp;
                if (endFp > this._buffer.length) {
                    var newBuff = new Buffer(endFp);
                    this._buffer.copy(newBuff);
                    this._buffer = newBuff;
                }
            }
            var len = buffer.copy(this._buffer, position, offset, offset + length);
            this._stat.mtime = new Date();
            if (this._flag.isSynchronous()) {
                this.syncSync();
                return len;
            }
            this.setPos(position + len);
            return len;
        };

        PreloadFile.prototype.read = function (buffer, offset, length, position, cb) {
            try  {
                cb(null, this.readSync(buffer, offset, length, position), buffer);
            } catch (e) {
                cb(e);
            }
        };

        PreloadFile.prototype.readSync = function (buffer, offset, length, position) {
            if (!this._flag.isReadable()) {
                throw new ApiError(0 /* EPERM */, 'File not opened with a readable mode.');
            }
            if (position == null) {
                position = this.getPos();
            }
            var endRead = position + length;
            if (endRead > this._stat.size) {
                length = this._stat.size - position;
            }
            var rv = this._buffer.copy(buffer, offset, position, position + length);
            this._stat.atime = new Date();
            this._pos = position + length;
            return rv;
        };

        PreloadFile.prototype.chmod = function (mode, cb) {
            try  {
                this.chmodSync(mode);
                cb();
            } catch (e) {
                cb(e);
            }
        };

        PreloadFile.prototype.chmodSync = function (mode) {
            if (!this._fs.supportsProps()) {
                throw new ApiError(14 /* ENOTSUP */);
            }
            this._stat.chmod(mode);
            this.syncSync();
        };
        return PreloadFile;
    })(file.BaseFile);
    exports.PreloadFile = PreloadFile;

    var NoSyncFile = (function (_super) {
        __extends(NoSyncFile, _super);
        function NoSyncFile(_fs, _path, _flag, _stat, contents) {
            _super.call(this, _fs, _path, _flag, _stat, contents);
        }
        NoSyncFile.prototype.sync = function (cb) {
            cb();
        };

        NoSyncFile.prototype.syncSync = function () {
        };

        NoSyncFile.prototype.close = function (cb) {
            cb();
        };

        NoSyncFile.prototype.closeSync = function () {
        };
        return NoSyncFile;
    })(PreloadFile);
    exports.NoSyncFile = NoSyncFile;
});
//# sourceMappingURL=preload_file.js.map
;